import React, { useState, useEffect } from "react";
import { Link } from "gatsby"
import Overlay from "./Overlay"

const MenuMobile = ({ links, isOpen, setIsOpen }) => {
  const [x, setX] = useState(0)
  const [opacity, setOpacity] = useState(0)
  useEffect(() => {
    if (isOpen) {
      setTimeout( () => {
        setX(0);
        setOpacity(100);
      }, 100);
    } else {
      setOpacity(0);
      setX(-0.75);
    }
  }, [isOpen])
  return (
    <Overlay isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={`container flex flex-col justify-center`}>
        <ul className={`text-center flex flex-col justify-center`}>
          {links.map((link, key) => (
            <li
              className={`my-3
              transition-all ease-in-out
              ${!isOpen ? `translate-x-0` : `-translate-x-36`}`}
              style={{
              transform: `translateX(${x}rem)`,
              opacity: `${opacity}`,
              transition: `transform 300ms ease-in-out ${(key * 100)}ms, opacity 200ms ease-in-out ${(key * 100)}ms`,
              }}
              key={`menu_mobile_link${key}`}
            >
              <Link
                className="font-semibold text-3xl text-gray-900 hover:text-gray-600 transition-colors duration-200"
                // activeClassName="text-annmade-1.0-gold"
                to={link.to}
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Overlay>
  )
}

export default MenuMobile
